import { APIService } from "services";

export const getAbout = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllAbout(pageNo,pageSize);
    }
    else{
        try {
            res = await searchAbout(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addAbout = (data) => {
return APIService.api().post(`/About`,data)
}
export const updateAbout = (id,data) => {
return APIService.api().patch(`/About/${id}`,data)
}
export const getAllAbout = (pageNo,pageSize) => {
return APIService.api().get(`/About/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneAbout = (id) => {
return APIService.api().get(`/About/${id}`)
}
export const searchAbout = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/About/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteAbout = (id) => {
return APIService.api().delete(`/About/${id}`)
}
